import { PartyTypeEnum } from '@shared/enums/party-type.enum';
import { SBBOnboardingParties } from './models';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class InitialOnboardingPartiesStateService {
	public initialState: SBBOnboardingParties = {
		business: {
			email: '',
			partyType: PartyTypeEnum.BUSINESS
		},
		primaryIndividual: {
			email: '',
			partyType: PartyTypeEnum.INDIVIDUAL,
			partyOnboardingRelationship: {
				partyType: PartyTypeEnum.INDIVIDUAL
			},
			existingCustomerLoginResponse: null
		},
		additionalShareholders: []
	};
}
